/**
 * Encode/decode .skjv file format.
 * Format: "skjv" prefix + hex-encoded JSON string.
 */

const MAGIC = 'skjv';

/** Encode a JSON-serializable object to the .skjv hex format. */
export function encodeSkjv(data: unknown): string {
  const json = JSON.stringify(data);
  const hex = Array.from(new TextEncoder().encode(json))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  return MAGIC + hex;
}

/** Decode a .skjv hex string back to a JSON string. Returns raw JSON on legacy (plain JSON) files. */
export function decodeSkjv(content: string): string {
  if (content.startsWith(MAGIC)) {
    const hex = content.slice(MAGIC.length);
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
      bytes[i / 2] = parseInt(hex.slice(i, i + 2), 16);
    }
    return new TextDecoder().decode(bytes);
  }
  // Legacy: plain JSON content — pass through
  return content;
}
